import { gql } from '@apollo/client';

const query = gql`
  query searchSuggestSitemapCategories($params: JSONObject) {
    searchSuggestSitemapCategories(params: $params)
  }
`;

module.exports = query;
